window.exportFile = function(url, filterParams) {
  const dialog = bootbox.dialog({
    message: '<p class="text-left mb-0"><i class="fa fa-spinner fa-spin"></i> Processing export, please wait ...</p>',
    closeButton: false
  });
  
  const urlWithParams = new URL(url, window.location.origin);
  
  for (const key in filterParams) {
    urlWithParams.searchParams.append(key, filterParams[key]);
  }
  
  fetch(urlWithParams, {
    method: 'GET',
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Export failed with status: ${response.status}`);
    }
    
    const contentDisposition = response.headers.get('Content-Disposition');
    if (contentDisposition && contentDisposition.includes('attachment')) {
      return response.blob().then(blob => {
        let filename = 'export.csv'; // Fallback
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        } 
        else if (contentDisposition.includes("filename*=UTF-8''")) {
          const encodedFilename = contentDisposition.split("filename*=UTF-8''")[1].split(';')[0];
          filename = decodeURIComponent(encodedFilename);
        }
        else if (contentDisposition.includes('filename=')) {
          filename = contentDisposition.split('filename=')[1]?.replace(/"/g, '').split(';')[0] || filename;
        }
        
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        return { success: true, filename };
      });
    }
  })
  .then(data => {
    setTimeout(() => {
      dialog.modal('hide');
      showNotification('success', 'Exported successfully');
    }, 500);
  })
  .catch(error => {
    console.error('Export error:', error);
    setTimeout(() => {
      dialog.modal('hide');
      showNotification('error', `Export failed: ${error.message}`);
    }, 500);
  });
}
